/* eslint-disable @typescript-eslint/no-explicit-any */
import {IFormField} from 'models/Common'
import {
 convertToDateEpoch,
 formatDateForDB,
} from 'utils/helper'

export const createFilterPayload = async (
 fields: any | undefined,
 formData?: IFormField | null
) => {
 const payload: IFormField = {}
 let count = 0
 if (fields) {
  for (const field of fields) {
   const inputType = field.fieldMetadata.inputType
   const fieldId = field.fieldId
   let value = formData?.[fieldId]
   if (
    ['DATE_RANGE_PICKER', 'DATE_PICKER'].includes(inputType)
   ) {
    const toFieldId = field?.fieldMetadata?.toDateFieldId
    const dateFormat = field?.fieldMetadata?.dateFormat
    if (value) {
     value =
      dateFormat === 'Epoch'
       ? convertToDateEpoch(value)
       : formatDateForDB(value)
    }
    if (
     inputType === 'DATE_RANGE_PICKER' &&
     formData?.[toFieldId]
    ) {
     payload[toFieldId] =
      dateFormat === 'Epoch'
       ? convertToDateEpoch(formData[toFieldId])
       : formatDateForDB(formData[toFieldId])
    }
   } else {
    if (value) {
     value = value.toString()
    }
   }
   if (value) {
    count++
    payload[fieldId] = value
   }
  }
 }
 payload.totalAppliedFilters = count
 return payload
}
